/**
 * Notification Popup
 * ------------------------------------------------------------------------------
 * Shows a notification form in a Photoswipe popup when a product variant is sold out.
 * The form is loaded via AJAX from the api-notification.liquid section.
 *
 * @usage
 * To use this feature, add the following attributes to your button:
 * - data-handle="{{ product.handle }}"
 * - data-variant-id="{{ variant.id }}"
 *
 * Example:
 * <button
 *   type="button"
 *   data-handle="{{ product.handle }}"
 *   data-variant-id="{{ variant.id }}"
 * >
 *   Notify me when available
 * </button>
 *
 * Then initialize:
 * new NotificationPopup(button);
 */

const settings = {
  templateIndex: 1,
};

const options = {
  history: false,
  focus: false,
  mainClass: 'pswp--notification pswp--not-close-btn',
  closeOnVerticalDrag: false,
};

class NotificationPopup {
  constructor(button) {
    this.button = button;
    this.a11y = window.theme.a11y;

    // Set the trigger element before calling trapFocus
    this.a11y.state.trigger = this.button;

    this.handle = this.button.getAttribute('data-handle');
    this.variantId = this.button.getAttribute('data-variant-id');

    this.init();
  }

  init() {
    // Build the URL for fetching the notification form
    const variantParam = this.variantId ? `&variant=${this.variantId}` : '';
    const url = `${theme.routes.root}products/${this.handle}?section_id=api-notification${variantParam}`;

    // Fetch and load the notification form
    this.loadPhotoswipeFromFetch(url);
  }

  loadPhotoswipeFromFetch(url) {
    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        const items = [
          {
            html: data,
          },
        ];

        new window.theme.LoadPhotoswipe(items, options, settings.templateIndex);
      })
      .catch((error) => console.log('error: ', error));
  }
}

export {NotificationPopup};
